import type { CardWalletsTranslations } from "../interfaces/cardWallets";

export const cardWalletsTranslations: CardWalletsTranslations = {
  page_title: "Carteira de cartões",
  page_subtitle:
    "Credite ou corrija o saldo em USD com que uma organização carrega seus cartões. Cada movimento fica registrado com sua referência.",
  refresh_button: "Atualizar",
  refresh_aria: "Atualizar o saldo e os movimentos",
  action_retry: "Tentar de novo",
  field_organization: "Organização",
  field_organization_required_hint: "Escolha a organização cujo saldo você vai mover.",
  field_organization_hint: "Ao escolhê-la, abrimos a carteira de cartões dela.",
  org_picker_placeholder: "Buscar por nome, e-mail ou id…",
  org_picker_loading: "Carregando organizações…",
  org_picker_empty: "Não encontramos nenhuma organização.",
  org_picker_searching: "Buscando…",
  org_picker_search_error: "Não conseguimos buscar organizações. Tente de novo.",
  org_picker_catalog_error: "Não conseguimos carregar a lista de organizações.",
  org_picker_catalog_truncated: "Há mais organizações do que cabem na lista: busque por nome ou id.",
  landing_title: "Escolha uma organização para ver sua carteira de cartões",
  landing_body:
    "Aqui você verá o saldo em USD com que ela carrega seus cartões, o histórico de movimentos e poderá creditá-lo ou corrigi-lo. Só é possível ajustar o saldo das organizações cujos cartões funcionam com Coloca Crypto.",

  wallet_balance_label: "Saldo disponível",
  wallet_loading: "Carregando o saldo",
  wallet_pending: "Pendente {{amount}}",
  wallet_id_label: "Carteira",
  wallet_id_copied: "Copiamos o id da carteira.",
  wallet_id_copy_action: "Copiar o id da carteira",
  wallet_status_active: "Ativa",
  wallet_status_frozen: "Congelada",
  wallet_status_suspended: "Suspensa",
  wallet_status_closed: "Fechada",
  wallet_status_notice: "Esta carteira está {{status}}. O movimento será registrado mesmo assim.",
  wallet_just_created: "Esta organização não tinha carteira de cartões; acabamos de abrir uma, vazia.",
  wallet_error_title: "Não conseguimos ler o saldo",
  wallet_error_body:
    "Sem o saldo não podemos mostrar o antes e o depois de um movimento, então as ações ficam desativadas.",
  action_credit: "Creditar saldo",
  action_debit: "Debitar saldo",
  actions_footnote: "Não é possível desfazer. Para corrigir, é preciso registrar o movimento contrário.",

  program_crypto: "Coloca Crypto",
  program_cards: "Coloca Cards",
  program_none: "Sem programa",
  ineligible_bloque:
    "Os cartões desta organização funcionam com Coloca Cards. O saldo é administrado pelo provedor e não se ajusta por aqui.",
  ineligible_no_program:
    "Esta organização ainda não tem programa de cartões, então não há saldo para ajustar.",
  ineligible_currency: "Esta carteira não está em USD, então não pode ser ajustada por aqui.",
  ineligible_wallet_type: "Esta carteira não é a de cartões da organização.",

  dialog_title_credit: "Creditar saldo",
  dialog_title_debit: "Debitar saldo",
  dialog_description_credit: "Registre um depósito em USD já confirmado na tesouraria da Coloca.",
  dialog_description_debit:
    "Registre uma correção que reduz o saldo da carteira de cartões desta organização.",
  stepper_label: "Etapas do movimento",
  step_data: "Dados",
  step_review: "Revisão",
  step_result: "Resultado",
  mode_banner_credit: "Você vai creditar saldo para {{name}} · Carteira de cartões · USD",
  mode_banner_debit: "Você vai debitar saldo de {{name}} · Carteira de cartões · USD",
  field_reference: "Referência do depósito",
  field_reference_hint:
    "O identificador com que você vai conciliar: id do depósito, número do chamado ou lote. Não pode se repetir nesta carteira, e é o único texto que restará para quem ler isto depois.",
  field_reference_placeholder: "Ex.: DEP-2026-10-14-ACME",
  field_reference_count: "{{used}} / 120",
  field_amount: "Valor",
  field_amount_hint: "Em USD, com no máximo 2 casas decimais.",
  action_cancel: "Cancelar",
  action_review: "Revisar",
  action_back: "Voltar",

  validation_reference: "Escreva a referência com que você vai conciliar este movimento.",
  validation_reference_long: "A referência não pode passar de 120 caracteres.",
  validation_amount: "Escreva um valor maior que zero.",
  validation_amount_precision: "O valor aceita no máximo 2 casas decimais.",
  validation_amount_over_balance: "O saldo disponível é {{balance}}; não dá para debitar {{amount}}.",

  review_heading_credit: "Você vai creditar saldo para {{name}}",
  review_heading_debit: "Você vai debitar saldo de {{name}}",
  review_organization: "Organização",
  review_wallet: "Carteira",
  review_wallet_value: "Cartões · USD · {{short}}",
  review_balance_before: "Saldo antes",
  review_movement: "Movimento",
  review_balance_after: "Saldo depois",
  review_reference: "Referência",
  review_client_sees:
    'No histórico da organização aparecerá como "Manual balance adjustment", com a data e o valor. O cliente não vê a referência que você escreveu.',
  review_webhook_credit:
    "Se a organização tiver um webhook configurado, avisamos sobre o crédito. Não enviamos e-mail nem notificação no app.",
  review_webhook_debit:
    "Um débito não avisa ninguém: a organização verá o saldo menor sem explicação. Avise-a pelo canal adequado.",
  review_irreversible:
    "Isto não pode ser desfeito. Para corrigir, é preciso registrar o movimento contrário, que fica como um segundo registro no histórico.",
  review_checkbox_credit: "Confirmo que o depósito em USD já está confirmado na tesouraria da Coloca.",
  review_checkbox_debit: "Confirmo que devo retirar este saldo e que já avisei a organização.",
  review_balance_moved:
    "O saldo mudou enquanto você revisava: agora é {{balance}}. Confira o resultado antes de confirmar.",
  action_confirm_credit: "Registrar o crédito · {{amount}}",
  action_confirm_debit: "Registrar o débito · {{amount}}",

  done_label: "Movimento registrado",
  done_pill_credit: "Creditado",
  done_pill_debit: "Debitado",
  done_amount: "Valor",
  done_balance_before: "Saldo antes",
  done_balance_after: "Saldo depois",
  action_another: "Registrar outro movimento",
  action_close: "Fechar",

  error_zero: "Escreva um valor maior que zero.",
  error_currency: "Esta carteira não está em USD, então não pode ser ajustada por aqui.",
  error_ineligible:
    "Os cartões desta organização funcionam com Coloca Cards e o saldo é administrado pelo provedor. Não pode ser ajustado por aqui.",
  error_insufficient: "O saldo disponível é {{balance}}; não dá para debitar {{amount}}.",
  error_not_found: "Não encontramos esta carteira. Pode ter sido fechada enquanto você trabalhava.",
  error_not_found_action: "Buscar a organização de novo",
  error_duplicate_title: "Esta referência já foi usada",
  error_duplicate_body:
    'Já existe um movimento com a referência "{{reference}}" nesta carteira. O dinheiro foi movido uma única vez, na primeira tentativa. Não repita.',
  error_duplicate_see: "Ver o movimento",
  error_duplicate_change: "Mudar a referência",
  error_duplicate_off_page:
    "O movimento não está nesta página do histórico. Removemos os filtros para você encontrá-lo.",
  error_rate_limited: "Só é possível registrar um movimento por minuto. Espere um momento e tente de novo.",
  error_rate_limited_retry: "Tentar em {{seconds}} s",
  error_rate_limited_ready: "Você já pode tentar de novo.",
  error_permission:
    "Não conseguimos autorizar o movimento. Somente a equipe autorizada a movimentar dinheiro pode ajustar saldos; se você deveria poder, peça para ser incluído.",
  error_unconfirmed_title: "Não sabemos se foi registrado",
  error_unconfirmed_body:
    "Não recebemos resposta do servidor. O movimento pode ter sido registrado. Não repita com a mesma referência até verificar.",
  error_unconfirmed_check: "Verificar",
  error_unconfirmed_not_placed: "Não foi registrado. Você pode tentar de novo com a mesma referência.",
  error_unconfirmed_still: "Ainda não conseguimos verificar. Tente de novo em instantes.",
  error_generic: "Não conseguimos registrar o movimento. Tente de novo.",

  history_title: "Movimentos desta carteira",
  col_date: "Data",
  col_movement: "Movimento",
  col_reference: "Referência",
  col_by: "Registrado por",
  col_amount: "Valor",
  badge_manual_adjustment: "Ajuste manual",
  by_you: "Você",
  by_unavailable: "Não disponível",
  by_unavailable_card: "Autor não disponível neste registro",
  by_unavailable_tooltip:
    "Este tipo de registro não devolve quem o fez. Fica guardado no backend, mas não chega a esta tela.",
  filter_type: "Tipo",
  filter_type_all: "Todos",
  filter_direction: "Direção",
  filter_direction_all: "Todas",
  filter_direction_in: "Entradas",
  filter_direction_out: "Saídas",
  filter_dates: "Intervalo de datas",
  filter_clear: "Limpar filtros",
  empty_title: "Esta carteira ainda não tem movimentos",
  empty_description:
    "Os movimentos que você registrar aqui, e as recargas e transferências da organização, aparecerão nesta lista.",
  empty_filtered_title: "Não há movimentos com estes filtros",
  history_error: "Não conseguimos carregar os movimentos.",

  tx_type_topup: "Recarga",
  tx_type_transfer: "Transferência",
  tx_type_withdrawal: "Retirada",
  tx_type_fee: "Taxa",
  tx_type_deposit: "Depósito",
  tx_type_reversal: "Estorno",
  tx_type_adjustment: "Ajuste",
  tx_status_pending: "Pendente",
  tx_status_completed: "Concluído",
  tx_status_failed: "Falhou",
  tx_status_reversed: "Estornado",

  tx_desc_manual_adjustment: "Ajuste manual de saldo",
  tx_desc_wallet_recharge: "Recarga da carteira",
  tx_desc_card_crypto_deposit: "Depósito cripto no cartão",
  tx_desc_card_crypto_transfer: "Transferido para o cartão por um depósito cripto",
  tx_desc_internal_transfer: "Transferência entre carteiras",

  quote_button: "Cotar recarga",
  quote_title: "Cotador de recargas",
  quote_description:
    "Calcule quanto um cliente precisa depositar e quanto é creditado, e consulte a carteira para onde se deposita. Não movimenta dinheiro nem registra nada.",
  quote_close: "Fechar",

  quote_network_label: "Blockchain",
  quote_address_label: "Endereço da carteira",
  quote_address_copy_aria: "Copiar o endereço da carteira",
  quote_address_copied: "Copiamos o endereço da carteira.",
  quote_assets_label: "Ativos aceitos",
  quote_asset_contract: "Contrato: {{address}}",
  quote_pool_warning:
    "Somente {{assets}} na {{network}}. Qualquer outro ativo, ou o mesmo em outra rede, é perdido e não pode ser recuperado.",
  quote_pool_error: "Não conseguimos ler a carteira de depósito. Sem ela não dá para dizer para onde enviar.",
  quote_pool_retry: "Tentar de novo",

  quote_mode_label: "O que você sabe sobre o valor",
  quote_mode_deposit_title: "O cliente paga",
  quote_mode_deposit_description: "Você sabe quanto ele vai depositar e quer saber quanto é creditado.",
  quote_mode_credited_title: "O cliente quer recarregar",
  quote_mode_credited_description: "Você sabe quanto precisa ser creditado e quer saber quanto depositar.",
  quote_amount_label_deposit: "Quanto o cliente paga?",
  quote_amount_label_credited: "Quanto ele quer recarregar?",
  quote_amount_hint: "Em USD, com no máximo 2 casas decimais.",
  quote_commission_label: "Comissão",
  quote_commission_unlock: "Ajustar a comissão",
  quote_commission_hint: "{{percent}} % por padrão. Marque a caixa para mudá-la só nesta cotação.",
  quote_issue_amount_invalid: "Escreva um valor maior que zero.",
  quote_issue_commission_invalid: "A comissão deve estar entre 0 % e 100 %.",
  quote_result_pays: "O cliente paga",
  quote_result_deposit: "Precisa depositar",
  quote_result_commission: "Comissão ({{percent}} %)",
  quote_result_credited: "É creditado",
  quote_rounding_note: "Arredondamos para cima no centavo, então são creditados {{amount}}.",
  quote_empty: "Escreva um valor para ver a cotação.",
  quote_footnote:
    "É apenas um cálculo de referência: não reserva nem registra nada. Quando o depósito chegar, credite o saldo por esta tela com a referência dele.",
  two_factor_required:
    "Para ajustar saldos você precisa da verificação em duas etapas ativa. Ative-a em Configurações e volte.",
  two_factor_description_credit: "Você vai creditar {{amount}} para {{name}}.",
  two_factor_description_debit: "Você vai debitar {{amount}} de {{name}}.",
};
